export default __webpack_public_path__ + "static/media/avatarC1.ed676f4b.png";